import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { kebabCase } from 'lodash';

const UserRoleBaseButton = ({
  selected = false,
  disabled = false,
  onClick,
  display = '',
  icon = <FontAwesomeIcon size="2x" />,
  id = ''
}) => {
  const disabledStyles = `${disabled && 'opacity-25 cursor-not-allowed'}`;

  return (
    <button
      id={id}
      data-testid={`user-role-${kebabCase(id)}`}
      // original style
      // style={{ width: '124px', height: '96px' }}
      style={{ width: '154px', height: '96px' }}
      className={`group border-cornflower-blue-500 border p-2 rounded mr-2 focus:outline-hidden
        ${
          selected
            ? 'bg-cornflower-blue-500 text-white font-bold'
            : 'active:bg-white/50 bg-white hover:bg-blue-200/25 hover:active:bg-blue-200/50 hover:cornflower-blue-200 text-cornflower-blue-500'
        } ${disabledStyles}`}
      type="button"
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      <div
        className={`whitespace-nowrap truncate ${
          selected ? 'text-white' : 'text-cornflower-blue-500'
        }`}
      >
        {display}
      </div>
    </button>
  );
};

UserRoleBaseButton.propTypes = {
  id: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func.isRequired
};

export default UserRoleBaseButton;
